import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SpeciesNameService } from './species-name.service';
import { SpeciesNameSearchCriteria } from './species-name-search-criteria';
import { ReportService } from '../../service/report.service';
import { AllSelectedMode } from '../assessment-selector/all-selected-enum';
import { PagedResponse } from '../../../domain/response/PagedResponse';
import { MessageDialogComponent } from '../../../common/message-dialog/message-dialog.component';

@Component({
  selector: 'app-species-selector',
  templateUrl: './species-selector.component.html',
})
export class SpeciesSelectorComponent implements OnInit {
  @ViewChild('selectAll') selectAll;
  @ViewChild('speciesSelectorModal', { static: true })
  public speciesSelectorModal: ModalDirective;

  @Output()
  speciesSelectorEvent = new EventEmitter();

  @ViewChild('messageDialog', { static: true })
  messageDialog: MessageDialogComponent;

  public allSelectedModeEnum = AllSelectedMode;
  allSelectedMode = AllSelectedMode.none;

  public loading = true;
  public addRequestInProgress = false;
  
  searchResponse: PagedResponse<any> = null;
 
  selectedIds: Set<number> = new Set();
  criteria = new SpeciesNameSearchCriteria();
  
  public allSpeciesSearchResponse: PagedResponse = {
    searchResults: [],
    numberOfPages: 0,
    page: 1,
    pageSize: 0,
    total: 0,
    responseMessages: []
  };

  private _reportId: number;
  
  constructor(
    private speciesNameService: SpeciesNameService,
    private reportService: ReportService
  ) {}

  @Input()
  public set reportId(reportId: number) {
    this._reportId = reportId;
  }

  ngOnInit() {
    this.onSearch();
  }

  start(_reportId: number) {
    this.reportId = _reportId;
    this.criteria.reportId = _reportId; //set directly as causes occasional issue otherwise
    this.ngOnInit();
    this.speciesSelectorModal.show();
  }

  onSearch(getFullList = true) {
    
    this.speciesNameService
      .findSpeciesNames(this.criteria)
      .subscribe((pagedResponse: PagedResponse<any>) => {
        this.searchResponse = pagedResponse;
          
      });
    if (getFullList) { //ignore this when page changed
        this.loading = true;
        this.selectedIds.clear();
        if (this.selectAll !== undefined){        
          this.selectAll.nativeElement.indeterminate = false;     
        }
        this.allSelectedMode = AllSelectedMode.none;
        this.loadAllSpecies();
      }
  }

  loadAllSpecies() {
    const allSpeciesSearchCriteria = { ...this.criteria};
    allSpeciesSearchCriteria.pageSize = 10000; // get all species for the report
    this.speciesNameService
    .findSpeciesNames(allSpeciesSearchCriteria)
    .subscribe((allResponse) => {
      this.allSpeciesSearchResponse = allResponse;
      this.loading = false;
    });
  }

  onMatchAgainstReportChange() {
    this.onSearch();
  }

  onClear() {
    this.loading = true;
    this.criteria.nameCriteria = '';
    this.criteria.pageNumber = 1;
    this.selectedIds.clear();
    this.onSearch();
    if (this.selectAll !== undefined){        
      this.selectAll.nativeElement.indeterminate = false;     
    }
    this.allSelectedMode = AllSelectedMode.none;
  }

  onAdd() {
    this.addRequestInProgress = true;
          this.reportService
            .addAssessments(this._reportId, this.getSelectedSpeciesList())
            .subscribe(() => { 
              this.onSearch();
              this.addRequestInProgress = false;
            });
  }

  onClose() {
    this.speciesSelectorModal.hide();
    this.speciesSelectorEvent.emit('Closed');
  }

  onPageChanged(event: any): void {
    // must update pageNumber from event before search
    this.criteria.pageNumber = event.page;
    this.onSearch(false);
  }

  getSelectedSpeciesList(): number[] {
    switch (this.allSelectedMode) {
     case AllSelectedMode.all:
      if (this.allSpeciesSearchResponse.searchResults !== null){
      return [...this.allSpeciesSearchResponse.searchResults.filter(x => !x.includedInReport).map(x => x.speciesId)];
      } else {
        return [];
      }
      case AllSelectedMode.partial:
      return [...this.selectedIds];
    case AllSelectedMode.none:
      return [];
    }
  }

  toggleSelection(e, i) {
    const species = this.searchResponse.searchResults[i];

    if (this.allSelectedMode !== AllSelectedMode.partial) {
        this.allSelectedMode = AllSelectedMode.partial;
    }
    if (this.selectedIds.has(species.speciesId)) {
      this.selectedIds.delete(species.speciesId);
    } else {
      this.selectedIds.add(species.speciesId);
    }

    if (this.selectedIds.size === 0) {
      this.selectAll.nativeElement.indeterminate = false;
    } else {
      this.selectAll.nativeElement.indeterminate = true;
    }
  }

  onSelectAll() {
    switch (this.allSelectedMode) {
      case AllSelectedMode.all:
        this.allSelectedMode = AllSelectedMode.none;
        this.selectedIds.clear();
        break;
      case AllSelectedMode.none:
        this.allSelectedMode = AllSelectedMode.all;
        this.selectedIds = new Set(this.allSpeciesSearchResponse.searchResults.filter(x => !x.includedInReport).map(x => x.speciesId));
        break;
      case AllSelectedMode.partial:
        this.allSelectedMode = AllSelectedMode.all;
        this.selectedIds = new Set(this.allSpeciesSearchResponse.searchResults.filter(x => !x.includedInReport).map(x => x.speciesId));
        break;
    }
  }
}
